

  export default {
    name: "InsurerPageRelatedProductSection",
    props: {
      data: {
        type: Array,
        default: () => ([]),
      },
      categoryInfo: {
        type: Object,
        default: () => ({
        }),
      },
    },
    data() {
      return {
        strapiData: [],
        numOfProductRPSTSav: 0,
        numOfProductRPSav: 0,
        numOfProductRPTCi: 0,
        numOfProductRPWlci: 0,
        numOfProductRPTCancer: 0,
        numOfProductRPMedical: 0,
        numOfProductRPAnnuity: 0,
        numOfProductRPTLife: 0,
        numOfProductRPWLProtection: 0,
        numOfProductRPHome: 0,
        numOfProductRPTravel: 0,
        numOfProductRPPersonalAccident: 0,
        showMore: true,
      }
    },
    computed: {
      numOfRelatedProduct() {
        return this.numOfProductRPSTSav + this.numOfProductRPSav + this.numOfProductRPTCi + this.numOfProductRPWlci + this.numOfProductRPTCancer + this.numOfProductRPMedical + this.numOfProductRPAnnuity + this.numOfProductRPTLife + this.numOfProductRPWLProtection + this.numOfProductRPTravel + this.numOfProductRPPersonalAccident + this.numOfProductRPHome
      },
      title() {
        if (this.categoryInfo) {
          const cat = this.categoryInfo.CategoryDetail.filter((item) => item.CategoryName === this.$route.params.cat);
          if(cat.length > 0)
            return cat[0].CategoryDisplayName;
          else
            return '';
        }
        return null;
      },
      desc() {
        if (this.categoryInfo) {
          const cat = this.categoryInfo.CategoryDetail.filter((item) => item.CategoryName === this.$route.params.cat);
          if(cat.length > 0)
            return cat[0].CategoryDisplayDesc;
          else
            return '';
        }
        return null;
      },
      category(){
        if (this.categoryInfo) {
          const cat = this.data.filter((item) => item.CategoryName === this.$route.params.cat)
          if(cat.length > 0)
          {
            return cat[0]
          }
        }
        return null;
      },
    },
    create() {
    },
    methods: {
      hasRelatedProducts: (data) => {
        return data?.RPSTSav?.length ||
          data?.RPSav?.length ||
          data?.RPTCi?.length ||
          data?.RPWlci?.length ||
          data?.RPTCancer?.length ||
          data?.RPMedical?.length ||
          data?.RPAnnuity?.length ||
          data?.RPTLife?.length ||
          data?.RPWLProtection?.length ||
          data?.RPTravel?.length ||
          data?.RPPersonalAccident?.length ||
          data?.RPHome?.length
      },
      paramForMedical(item) {
        return item?.Params ? item?.Params : 'age=35&gender=1'
      },
      paramForTermLife(item) {
        return item?.Params ? item?.Params : 'age=35&targetPeriod=10&gender=1'
      },
      paramForSaving(item) {
        return item?.Params ? item?.Params : 'policy_year=20&risk_level=Growth'
      },
      paramForAnnuity(item) {
        return item?.Params ? item?.Params : 'objective=savings'
      },
      paramForSTSaving(item) {
        return item?.Params ? item?.Params : 'year=5'
      },

      updateProductCounter(relatedProductCategory) {
        if (relatedProductCategory === 'RPSTSav') { 
          this.numOfProductRPSTSav++
        }
        if (relatedProductCategory === 'RPSav') { 
          this.numOfProductRPSav++
        }
        if (relatedProductCategory === 'RPTCi') { 
          this.numOfProductRPTCi++
        }
        if (relatedProductCategory === 'RPWlci') { 
          this.numOfProductRPWlci++
        }
        if (relatedProductCategory === 'RPTCancer') { 
          this.numOfProductRPTCancer++
        }
        if (relatedProductCategory === 'RPMedical') { 
          this.numOfProductRPMedical++
        }
        if (relatedProductCategory === 'RPAnnuity') { 
          this.numOfProductRPAnnuity++
        }
        if (relatedProductCategory === 'RPTLife') { 
          this.numOfProductRPTLife++
        }
        if (relatedProductCategory === 'RPWLProtection') { 
          this.numOfProductRPWLProtection++
        }
        if (relatedProductCategory === 'RPTravel') { 
          this.numOfProductRPTravel++
        }
        if (relatedProductCategory === 'RPPersonalAccident') { 
          this.numOfProductRPPersonalAccident++
        }
        if (relatedProductCategory === 'RPHome'){
          this.numOfProductRPHome++
        }
      },
      getCategoryProducts(cat) {
        if (this.category?.[cat].length > 0 && this.category[cat].length <= 3) {
          this.showMore = false;
        }
        if (this.showMore) {
          return this.category?.[cat].slice(0, 3);
        }
        return this.category?.[cat];
      },
      addProducts() {
        this.showMore = false;
      }
    },
   
}
